import React from "react"
import Swiper from "swiper"

import Image from "./../image"

class HowToUse extends React.Component {
  componentDidMount() {
    new Swiper(".how-to-use .swiper-container", {
      slidesPerView: 3,
      spaceBetween: 40,
      // Responsive breakpoints
      breakpoints: {
        // when window width is <= 768px
        768: {
          slidesPerView: 1.5,
          spaceBetween: 0,
        },
      },
    })
  }

  render() {
    return (
      <div className="how-to-use">
        <div className="container is-slim">
          <div className="columns">
            <div data-aos="fade-up" className="column is-4">
              <div className="title-container">
                <h2 className="title is-3 mb-0">HOW TO USE</h2>
                <small className="has-text-grey-light">簡単3つのステップ</small>
              </div>
            </div>
            <div data-aos="fade-up" className="column">
              <div className="swiper-container">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div className="image">
                      <Image filename="index/how-to-use-1.png" />
                    </div>
                    <div className="title is-5 mt-20">料理を注文</div>
                    <div className="text">
                      専用アプリまたはWEBから料理を注文します
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="image">
                      <Image filename="index/how-to-use-2.png" />
                    </div>
                    <div className="title is-5 mt-20">受け取りに行く</div>
                    <div className="text">
                      受け取り時刻になったら
                      <br />
                      お店に料理を受け取りに行きます
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="image">
                      <Image filename="index/how-to-use-3.png" />
                    </div>
                    <div className="title is-5 mt-20">いただきます</div>
                    <div className="text">
                      料理を受け取れたら
                      <br />
                      好きな場所で召し上がれます
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default HowToUse
